import React, { useState } from "react";
import Navbar from "../components/navbar";
import CommitteeTable from "../components/committee-table";
import CTAButtons from "../components/sticky-button";
import BrochureForm from "../components/brochure-form";
import Footer from "../components/Footer";
import PageHeader from "./PageHeader";
import "../components/governing.css";

const committeeDataByYear = {
  "A.Y. 2023-24": [
    { section: "", no: "1", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Sanjeev Vishwanathan", designation: "Director – Global Industry Relations, Wipro", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Dyneshwar Kambli", designation: "IP Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Vishwajeet Sukhija", designation: "Apple", councilPosition: "Member" },
    { section: "", no: "5", name: "Ms. Suman Pai", designation: "Examiner, IMC, RBNQA", councilPosition: "Member" },
    { section: "", no: "6", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "7", name: "Ms. Sonu Gupta", designation: "Assistant Prof, Dy. Director & TPO, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. Shirshendu Maitra", designation: "Assistant Professor & HoD – Aca. TIMSCDR", councilPosition: "Member" },
    { section: "", no: "9", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convenor" },
    { section: "Special invitees", no: "9", name: "Ms. Rashmi Vipat", designation: "Asst. Prof. & Exam In-charge, TIMSCDR", councilPosition: "Member" },
    { section: "Special invitees", no: "10", name: "Mr. Brijesh Pandey", designation: "Asst. Prof., & TPO, TIMSCDR", councilPosition: "Member" }
  ],
  "A.Y. 2022-23": [
    { section: "", no: "1", name: "Mr. Prasanna Lohar", designation: "Director, Association of Emerging Technologies India", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Dyneshwar Kambli", designation: "Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Apurb Sinha", designation: "Head – CRM and Analytics (APAC), Invesco", councilPosition: "Member" },
    { section: "", no: "5", name: "Mr. Vishwajeet Sukhija", designation: "Regional Business Head – Enterprise – Apple", councilPosition: "Member" },
    { section: "", no: "6", name: "Mr. Vikrant Pawar", designation: "Head of Engg. Grab-a-Grub Services Pvt. Ltd.", councilPosition: "Member" },
    { section: "", no: "7", name: "Ms. Suman Pai", designation: "Examiner, IMC, RBNQA", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "9", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convenor" },
    { section: "Special Invitees", no: "9", name: "Ms. Sonu Gupta", designation: "Assistant Prof, TPO, TIMSCDR", councilPosition: "Member" },
    { section: "Special Invitees", no: "13", name: "Mr. Brijesh Pandey", designation: "Asst. Prof., & TPO, TIMSCDR", councilPosition: "Member" },
    { section: "Special Invitees", no: "11", name: "Ms. Mira Gohil", designation: "Asst. Prof. & HoD – Aca., TIMSCDR", councilPosition: "Member" },
    { section: "Special Invitees", no: "10", name: "Dr. Pankaj Mudholkar", designation: "Associate Prof. In-charge Research, TIMSCDR", councilPosition: "Member" }
  ],
  "A.Y. 2021-22": [
    { section: "", no: "1", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Dyneshwar Kambli", designation: "Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Apurb Sinha", designation: "Head – CRM and Analytics (APAC), Invesco", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Vishwajeet Sukhija", designation: "Regional Business Head – Enterprise – Apple", councilPosition: "Member" },
    { section: "", no: "5", name: "Mr. Vikrant Pawar", designation: "Head of Engg. Grab-a-Grub Services Pvt. Ltd.", councilPosition: "Member" },
    { section: "", no: "6", name: "Ms. Suman Pai", designation: "Examiner, IMC, RBNQA", councilPosition: "Member" },
    { section: "", no: "7", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "8", name: "Dr. Pankaj Mudholkar", designation: "In-charge Research, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "9", name: "Ms. Sonu Gupta", designation: "Assistant Prof, TPO, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "10", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convenor" },
    { section: "Special Invitees", no: "11", name: "Ms. Mira Gohil", designation: "Asst. Prof. & HoD – Aca., TIMSCDR", councilPosition: "Member" },
    { section: "Special Invitees", no: "12", name: "Mr. Shirshendu Maitra", designation: "Asst. Prof.", councilPosition: "Member" },
    { section: "Special Invitees", no: "13", name: "Mr. Brijesh Pandey", designation: "Asst. Prof., & TPO, TIMSCDR", councilPosition: "Member" }
  ],
  "A.Y. 2020-21": [
    { section: "", no: "1", name: "Dr. Deven Shah", designation: "Vice Principal – Thakur College of Engineering and Technology", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Dnyaneshwar Kamble", designation: "Leading IP & Engineering for NGN, TCS", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Akshay Shah", designation: "Co Founder at Jhakaas Technologies Private Limited", councilPosition: "Member" },
    { section: "", no: "5", name: "Mr. Apurb Sinha", designation: "Head – CRM and Analytics (APAC), Invesco", councilPosition: "Member" },
    { section: "", no: "6", name: "Mr. Vishwajeet Sukhija", designation: "Account Executive, Microsoft", councilPosition: "Member" },
    { section: "", no: "7", name: "Ms. Suman Pai", designation: "Examiner, IMC, RBNQA", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "9", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convenor" },
    { section: "", no: "10", name: "Ms. Mira Gohil", designation: "Asst. Prof. & HoD Academics", councilPosition: "Member" },
    { section: "", no: "11", name: "Mr. Pankaj Mudholkar", designation: "Asst. Prof. In-charge Research, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "12", name: "Ms. Sonu Gupta", designation: "Asst. Prof.  & TPO", councilPosition: "Member" },
    { section: "", no: "13", name: "Mr. Brijesh Pandey", designation: "Asst. Prof & TPO", councilPosition: "Member" }
  ],
  "A.Y. 2019-20": [
    { section: "", no: "1", name: "Dr. Deven Shah", designation: "Vice Principal – Thakur College of Engineering and Technology", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Dyneshwar Kambli", designation: "Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Akshay Shah", designation: "Co Founder at Jhakaas Technologies Private Limited", councilPosition: "Member" },
    { section: "", no: "5", name: "Mr. Apurb Sinha", designation: "Head – CRM and Analytics (APAC), Invesco", councilPosition: "Member" },
    { section: "", no: "6", name: "Mr. Vishwajeet Sukhija", designation: "Account Executive, Microsoft", councilPosition: "Member" },
    { section: "", no: "7", name: "Ms. Suman Pai", designation: "Examiner, IMC", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "9", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convenor" },
    { section: "", no: "10", name: "Mr. Pankaj Mudholkar", designation: "Dy. Director, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "11", name: "Ms. Sonu Gupta", designation: "MR, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "12", name: "Ms. Aprajita Singh", designation: "HoD Academics, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "13", name: "Mr. Brijesh Pandey", designation: "TPO, TIMSCDR", councilPosition: "Member" }
  ],
  "A.Y. 2018-19": [
    { section: "", no: "1", name: "Dr Suresh Ukarande", designation: "Dean (Technology UoM) & Principal – K. J. Somaiya Institute of Engg. & Information Technology", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Sanjay Kimbahune", designation: "Senior Scientist and Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Sudhanshu Ojha", designation: "GM-D-link Academy, SAARC & NetProtect D-Link India Ltd.", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Dyneshwar Kambli", designation: "Consultant, TCS", councilPosition: "Member" },
    { section: "", no: "5", name: "Mr. Bharat Mandot", designation: "Co Founder at Jhakaas Technologies Private Limited", councilPosition: "Member" },
    { section: "", no: "6", name: "Mr. Apurb Sinha", designation: "Head – CRM and Analytics (APAC), Invesco", councilPosition: "Member" },
    { section: "", no: "7", name: "Ms. Suman Pai", designation: "Examiner, IMC, RBNQA", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. Vishwajeet Sukhija", designation: "Account Executive, Microsoft", councilPosition: "Member" },
    { section: "", no: "9", name: "Mr. Hemant Kale", designation: "Inspector of Police – Anti Terrorist Squad", councilPosition: "Member" },
    { section: "", no: "10", name: "Mr. V. N. Datta", designation: "Advisor, TEG", councilPosition: "Member" },
    { section: "", no: "11", name: "Dr. Vinita Gaikwad", designation: "Director, TIMSCDR", councilPosition: "Convener" },
    { section: "", no: "12", name: "Mr. Pankaj Mudholkar", designation: "Dy. Director, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "13", name: "Ms. Sonu Gupta", designation: "MR, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "14", name: "Ms. Aprajita Singh", designation: "HoD Academics, TIMSCDR", councilPosition: "Member" },
    { section: "", no: "15", name: "Mr. Brijesh Pandey", designation: "TPO, TIMSCDR", councilPosition: "Member" }
  ],
  "A.Y. 2017-18": [
    { section: "", no: "1", name: "Mr. Sudhanshu Ojha", designation: "General Manager – D’Link", councilPosition: "Member" },
    { section: "", no: "2", name: "Mr. Dyneshwar Kambli", designation: "Senior Consultant – TCS", councilPosition: "Member" },
    { section: "", no: "3", name: "Mr. Uday Wankawala", designation: "Chief Business Evangelist – Lemon Ideas", councilPosition: "Member" },
    { section: "", no: "4", name: "Mr. Bharat Mandot", designation: "Co Founder – Jhakaas Technologies Pvt. Ltd.", councilPosition: "Member" },
    { section: "", no: "5", name: "Dr. Vinita Gaikwad", designation: "Director", councilPosition: "Convenor" },
    { section: "", no: "6", name: "Ms. Aprajita Singh", designation: "HOD-ACA", councilPosition: "Member" },
    { section: "", no: "7", name: "Mr. Brijesh Pandey", designation: "TPO & Asst. Professor", councilPosition: "Member" },
    { section: "", no: "8", name: "Mr. Pankaj Mudholkar", designation: "Asst. Professor", councilPosition: "Member" },
    { section: "", no: "9", name: "Ms. Sonu Gupta", designation: "Asst. Professor", councilPosition: "Member" }
  ]
};

function Advisory() {
  const [showForm, setShowForm] = useState(false);
  const [selectedYear, setSelectedYear] = useState("A.Y. 2023-24");
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="governing-page-wrapper">
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
      <PageHeader
        title="Advisory Board"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Advisory Board" },
        ]}
      />

      <div className="governing-layout">
        <aside className="year-selector">
          <h3>
            <span className="year-selector-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </span>
            ACADEMIC YEAR
          </h3>
          <ul>
            {Object.keys(committeeDataByYear).map((year) => (
              <li
                key={year}
                className={year === selectedYear ? "active" : ""}
                onClick={() => setSelectedYear(year)}
              >
                {year}
              </li>
            ))}
          </ul>
        </aside>

        <main className="table-area">
          <div className="table-header-control-bar">
            <h3 className="governing-title">Members of Advisory Board - {selectedYear}</h3>
            <div className="table-actions-row">
              <div className="search-box-wrapper">
                <input
                  type="text"
                  placeholder="Search member..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              </div>
            </div>
          </div>

          <div className="tables-container">
            <CommitteeTable data={committeeDataByYear[selectedYear]} searchTerm={searchTerm} />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default Advisory;